import {useEffect, useState} from 'react';
import {getWebDownloadPosterTypeNames} from '@Libraries/poster-download-library';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {updateWebDownloadPosterTypeNames} from '@Components/download-panel/download-panel.reducer';

export const useGetWebDownloadPosterTypes = (): {isLoading: boolean} => {
  const posterTypeNames = useAppSelector((state) => {
    return state.downloadDialog.webDownloadPosterTypeNames;
  });
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const getAndStoreData = async (): Promise<void> => {
    if (posterTypeNames && posterTypeNames.length > 0) {
      return;
    }
    
    setIsLoading(true);
    try {
      const data = await getWebDownloadPosterTypeNames();
      dispatch(updateWebDownloadPosterTypeNames(data));
    } catch (error) {
      console.error('Failed to fetch web download poster types:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    void getAndStoreData();
  }, []);

  return {isLoading};
};
